import twitteContext from "context/twitteContext";
import React, { useState, useEffect, useContext } from "react";
import "./twittes.scss";
import icon from "../../../assets/images/Icon awesome-twitter.png";
import TakTwitte from "./TakTwitte";

const Twittes = () => {
  const { twittes, counter } = useContext(twitteContext);
  return (
    <div
      className="col-12 col-md-6 Twittes profileTwittes"
      style={{ marginTop: "20px" }}
    >
      <div className="title" style={{ fontWeight: "bold" }}>
        <img src={icon} alt="icon" /> توییت ها
        <hr />
      </div>
      <div className="row">
        {twittes.slice(0, counter).map((value, index) => (
          <TakTwitte value={value} index={index} twittes={twittes} />
        ))}
      </div>
    </div>
  );
};

export default Twittes;
